<header class="header__portal" id="top">
  <nav role="navigation">
    <a class="sr-text" href="#content">Skip to content</a>
    <img src="assets/imgs/logos/AmiLearn-Logo_Horizontal_4c.svg" width="160" height="31" alt="AmiLearn's Logo" title="AmiLearn">
    <!-- This nav is temporary and for easier testing between pages. It will not go to production -->
    <div class="test-links" *ngIf="showTestLinks">
      <a [routerLink]="['/new-user']" queryParamsHandling="preserve">New user</a>
      <a [routerLink]="['/registered-user']" queryParamsHandling="preserve">Registered</a>
      <a [routerLink]="['/subscribed-user']" queryParamsHandling="preserve">Subscribed</a>
      <a class="test" (click)="onClickTestAPI()">Test Protected API</a>
      <a class="test" (click)="onClickForceRefresh()">Force Refresh</a>
      <a class="test" (click)="onClickForceFederatedSignIn()">Force FederatedSignIn</a>
      <!-- <a (click)="onClickRevokeToken()">Revoke Token</a>
      <a (click)="onClickLocalSignOut()">Local SignOut</a>
      <a (click)="onClickCognitoLogout()">Cognito Logout</a> -->
    </div>
    <button *ngIf="isLocalEnv ||  (isAuthenticated$ | async)" (click)="onClickLogout()" class="btn-secondary-small logout" data-hover="Log out of AmiLearn Portal">LOG OUT</button>
    <button *ngIf="isLocalEnv ||  !(isAuthenticated$ | async)" (click)="onClickLogin()" class="btn-secondary-small">LOG IN</button>
  </nav>
</header>
